import { render } from "./aPayerMin.vue?vue&type=template&id=733b902c&scoped=true"
import script from "./aPayerMin.vue?vue&type=script&lang=js"
export * from "./aPayerMin.vue?vue&type=script&lang=js"

import "./aPayerMin.vue?vue&type=style&index=0&id=733b902c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-733b902c"]])

export default __exports__